import styled from 'styled-components'
import colors from '../../tokens/colors'
import fonts from '../../tokens/fonts'
import { defaultTheme } from '../../theming/data/defaultTheme'
import { composeTheme } from '../../utils/compose-theme'
import border from '../../tokens/border'

export const Item = styled.button.attrs((props) => composeTheme(props))`
  align-items: center;
  background: transparent;
  border: 0;
  cursor: pointer;
  font-family: ${fonts.inter};
  font-size: 1.4rem;
  font-style: normal;
  font-weight: ${(props) => props.theme.upperMenu.fontWeight};
  line-height: 1.7rem;
  padding: 1.1rem 1.6rem;
  border-left-color: ${(props) => props.theme.upperMenu.borderLeftColor};
  border-left-width: ${(props) => props.theme.upperMenu.borderLeftWidth};
  border-left-style: solid;
  border-bottom-color: ${(props) => props.theme.upperMenu.borderBottomColor};
  border-bottom-width: ${(props) => props.theme.upperMenu.borderBottomWidth};
  border-bottom-style: solid;
  border-top-color: ${(props) => props.theme.upperMenu.borderTopColor};
  border-top-width: ${(props) => props.theme.upperMenu.borderTopWidth};
  border-top-style: solid;

  &.last,
  &.single {
    border-right-color: ${(props) => props.theme.upperMenu.borderRightColor};
    border-right-width: ${(props) => props.theme.upperMenu.borderRightWidth};
    border-right-style: solid;
  }

  &.enabled {
    color: ${(props) => props.theme.upperMenu.color};
    &:hover {
      color: ${(props) =>
        props.theme.upperMenu.hoverColor !== colors.brandColorPrimaryPure
          ? props.theme.upperMenu.hoverColor
          : props.theme.brandColors.primaryPure};
      background-color: ${(props) =>
        props.theme.upperMenu.hoverBackgroundColor};
    }

    &:active {
      color: ${(props) =>
        props.theme.upperMenu.activeColor !== colors.brandColorPrimaryPure
          ? props.theme.upperMenu.activeColor
          : props.theme.brandColors.primaryPure};
      border-bottom-color: ${(props) =>
        props.theme.upperMenu.activeBorderBottomColor};
      background-color: ${(props) =>
        props.theme.upperMenu.activeBackgroundColor};
    }

    &:focus {
      outline: none;
      border-bottom-color: ${(props) =>
        props.theme.upperMenu.activeBorderBottomColor !==
        colors.brandColorPrimaryPure
          ? props.theme.upperMenu.activeBorderBottomColor
          : props.theme.brandColors.primaryPure};
    }
  }

  &:disabled {
    color: ${colors.neutralColorLowMedium};
    pointer-events: none;
  }

  &.negative {
    color: ${(props) => props.theme.upperMenu.negativeColor};
    border-bottom-color: ${(props) =>
      props.theme.upperMenu.negativeBorderBottomColor};

    &:hover {
      color: ${(props) =>
        props.theme.upperMenu.hoverColor !== colors.brandColorPrimaryPure
          ? props.theme.upperMenu.hoverColor
          : props.theme.brandColors.primaryPure};
      background-color: ${(props) =>
        props.theme.upperMenu.hoverBackgroundColor};
    }
  }

  &.active {
    color: ${(props) =>
      props.theme.upperMenu.activeColor !== colors.brandColorPrimaryPure
        ? props.theme.upperMenu.activeColor
        : props.theme.brandColors.primaryPure};
    border-bottom-color: ${(props) =>
      props.theme.upperMenu.activeBorderBottomColor !==
      colors.brandColorPrimaryPure
        ? props.theme.upperMenu.activeBorderBottomColor
        : props.theme.brandColors.primaryPure};
    background-color: ${(props) => props.theme.upperMenu.activeBackgroundColor};
  }

  ${(props) =>
    props.theme.upperMenu.borderRadius &&
    `
    &.first {
      border-radius: ${props.theme.upperMenu.borderRadius} ${border.radius.radiusNone} ${border.radius.radiusNone} ${props.theme.upperMenu.borderRadius};
    }
    &.last {
      border-radius: ${border.radius.radiusNone} ${props.theme.upperMenu.borderRadius} ${props.theme.upperMenu.borderRadius} ${border.radius.radiusNone};
    }
    &.single {
      border-radius: ${props.theme.upperMenu.borderRadius};
    }
  `}
`

Item.defaultProps = defaultTheme
